import { getCountries } from 'API/countries';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';
import i18n from 'i18n';
import { useMemo, useState } from 'react';
import useErrorStore from 'stores/error-store';
import { useUserData } from './use-user-data';

const useCountries = () => {
  useUserData();
  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const lang = i18n.languages[0];

  const [countries, setCountries] = useState<{ name: string; code: string }[]>([]);
  const countryOptions: OptionType[] = useMemo(() => countries.map((country) => ({ label: country.name, value: country.code })), [countries]);

  const fetchCountries = async () => {
    const res = await getCountries(lang);

    if (!res.error) {
      const countriesData = Array.isArray(res) ? res : Array.isArray(res?.countries) ? res.countries : Array.isArray(res?.data) ? res.data : [];
      setCountries(countriesData);
    } else {
      handleOpenErrorDialog(res?.error, '/countries', 'get');
    }
  };

  return { countries, countryOptions, fetchCountries };
};

export default useCountries;
